import { Badge } from "@shopify/polaris";
import type { MeResponse } from "../types";

import { t } from "../lib/i18n";

export function SubscriptionBadge({
  subscription,
}: {
  subscription: MeResponse["subscription"];
}) {
  if (!subscription.active) {
    return <Badge tone="warning">{t("未契約")}</Badge>;
  }
  const planLabel = subscription.plan_code
    ? subscription.plan_code.charAt(0).toUpperCase() + subscription.plan_code.slice(1)
    : "—";
  if (subscription.trial_ends_at) {
    return (
      <Badge tone="info">{t("{plan}（トライアル中）", { plan: planLabel })}</Badge>
    );
  }
  return <Badge tone="success">{planLabel}</Badge>;
}
